export default __webpack_public_path__ + "static/media/N2P_1881.6a95ea09.jpg";